module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Protective",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M35.5,55 C20.5,51.0912672 13,38.7911082 13,18.0995229 C14.9628906,18.0995229 30.8153298,10.6250463 35.5,5 C39.8550803,10.6250463 56.0522156,18.0995229 58,18.0995229 C58,38.286275 50.5,50.5864341 35.5,55 Z M35.5,50.8333333 C35.5,23.9512804 35.5,10.0623915 35.5,9.16666667 C31.564877,13.8542052 18.2488281,20.0829358 16.6,20.0829358 C16.6,37.3259235 22.9,47.576056 35.5,50.8333333 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99bd13a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/protective.vue
// module id = 652
// module chunks = 1